// find page js
window.addEventListener('DOMContentLoaded', function() {
    var current_index = 1;
    var selected_options = {};
    var step_wrapper_node = document.querySelector('.quiz-pc-step');

    var swiper = new Swiper('.quiz-slider', {
        allowTouchMove: false
    })
    // email
    document.querySelector('.quiz-email').addEventListener('click', function(e) {
        if (e.target && e.target.matches('.wizard__submit')) {
            var query = '';
            for (var key in selected_options) {
                query += key + '=' + selected_options[key] + '&';
            }
            query = query.slice(0, -1);
            this.querySelector('#hidden-1').value = window.location.origin + '/pages/quiz-result?' + query;
            setTimeout(function() {
                if (!document.querySelector('.quiz-email .globo-form-control[data-type="email"] .help-block.error')) {
                    slideTo(current_index + 1)
                }
            }, 500)
        }
    })
    // index start from 1
    function slideTo(index) {
        // console.log('slideTo', index);
        current_index = index
        swiper.slideTo(current_index - 1)
        updateStep(current_index - 1)
    }

    // slideTo(current_index)
    document.querySelectorAll('.find-page .js-option-item').forEach(function (item, index) {
        item.addEventListener('click', function() {
            var next_index = this.getAttribute('data-next');
            if (!next_index) {
                next_index = parseInt(current_index) + 1
            }
            slideTo(next_index)
            
            var option_wrapper = this.closest('.js-option-wrapper');
            if (!option_wrapper) return
            var option_title = this.closest('.js-option-wrapper').getAttribute('data-option-title');
            var option_value = this.getAttribute('data-option-value');
            console.log('option_title', option_title);
            console.log('option_value', option_value);
            if (option_title && option_value) {
                selected_options[option_title] = option_value;
            }
            console.log('selected_options', selected_options);
        })
    })

    document.querySelectorAll('.find-page button[name="back"]').forEach(function (item) {
        item.addEventListener('click', function() {
            slideTo(current_index - 1)
        })
    })
    document.querySelector('.find-page button[name="result"]').addEventListener('click', function() {
        console.log('selected_options', selected_options);
        var query = '';
        for (var key in selected_options) {
            query += key + '=' + selected_options[key] + '&';
        }
        query = query.slice(0, -1);
        console.log('query', query);
        window.location.href = '/pages/quiz-result?' + query;
    })
    document.querySelectorAll('.quiz-pc-step__item').forEach(function (item, index) {
        item.addEventListener('click', function() {
           if (this.classList.contains('active')) {
                slideTo(parseInt(index) + 1)
           }
        })
    })

    function updateStep(newPage) {
        step_wrapper_node.querySelectorAll('.quiz-pc-step__item').forEach(function (item, index) {
            // console.log('index', index);
            if (index <= newPage) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        })
        document.querySelector('.mobile-indexer .current-index').innerHTML = current_index
        if (current_index == 1) {
            document.querySelector('.mobile-indexer [name="back"]').classList
            .add('hidden')
        } else {
            document.querySelector('.mobile-indexer [name="back"]').classList
            .remove('hidden')
        }
    }
})